import React from 'react';
import { X, RotateCcw } from 'lucide-react';
import YearFilter from './YearFilter';
import CountryFilter from './CountryFilter';
import ValueRangeFilter from './ValueRangeFilter';
import WeightRangeFilter from './WeightRangeFilter';
import TrademarkFilter from './TrademarkFilter';
import ImporterFilter from './ImporterFilter';

export default function FiltersRail({
  open,
  onClose,
  filters,
  countries,
  years,
  onUpdateFilter,
  onClearFilters,
  onApply,
  hasActiveFilters,
  hasPendingFilterChanges,
  hasSearch,
}) {
  if (!open) return null;
  const canApply = Boolean(hasSearch && hasPendingFilterChanges);

  return (
    <aside className="w-[280px] shrink-0 flex flex-col border-r border-border-default bg-surface">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-border-default px-4 py-2.5 shrink-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-text-primary">Фильтры</span>
          {hasActiveFilters && (
            <button
              type="button"
              onClick={onClearFilters}
              className="inline-flex items-center gap-1 text-[11px] text-text-muted hover:text-red-500 dark:hover:text-red-400 transition-colors"
              title="Сбросить все фильтры"
            >
              <RotateCcw className="w-3 h-3" />
              Сбросить
            </button>
          )}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="grid h-7 w-7 place-items-center rounded-md text-text-muted hover:bg-hover hover:text-text-secondary transition-colors"
          aria-label="Закрыть фильтры"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>

      {/* Body */}
      <div className="flex-1 overflow-y-auto thin-scroll p-3 space-y-4">
        <YearFilter
          years={years}
          yearFrom={filters.yearFrom}
          yearTo={filters.yearTo}
          onChange={onUpdateFilter}
        />

        <CountryFilter
          countries={countries}
          value={filters.country}
          onChange={val => onUpdateFilter('country', val)}
        />

        <ValueRangeFilter
          valueMin={filters.valueMin}
          valueMax={filters.valueMax}
          onChange={onUpdateFilter}
        />

        <WeightRangeFilter
          weightMin={filters.weightMin}
          weightMax={filters.weightMax}
          onChange={onUpdateFilter}
        />

        <TrademarkFilter
          value={filters.trademark}
          onChange={val => onUpdateFilter('trademark', val)}
        />

        <ImporterFilter
          value={filters.importer}
          onChange={val => onUpdateFilter('importer', val)}
        />

        <div>
          <label className="block text-xs font-medium text-text-muted mb-1">
            Код товара (префикс)
          </label>
          <input
            type="text"
            value={filters.productCodePrefix || ''}
            onChange={e => onUpdateFilter('productCodePrefix', e.target.value)}
            placeholder="напр. 8510"
            className="w-full px-2.5 py-1.5 text-sm bg-app text-text-primary placeholder:text-text-disabled border border-border-default rounded-lg focus:outline-none focus:ring-1 focus:ring-ring-focus"
          />
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-border-default p-3 shrink-0 space-y-1.5">
        <button
          type="button"
          onClick={onApply}
          disabled={!canApply}
          className={`w-full rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${
            canApply
              ? 'bg-blue-600 text-white hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-400'
              : 'bg-app text-text-disabled cursor-not-allowed border border-border-default'
          }`}
          title={
            !hasSearch
              ? 'Сначала выполните поиск'
              : hasPendingFilterChanges
                ? 'Применить фильтры к текущему запросу'
                : 'Фильтры уже применены'
          }
        >
          Применить
        </button>
        <p className="text-center text-[10px] text-text-disabled">
          {!hasSearch
            ? 'Будут учтены при новом поиске'
            : hasPendingFilterChanges
              ? 'Текущая выдача ещё без этих изменений'
              : hasActiveFilters
                ? 'Фильтры уже в выдаче'
                : 'Фильтры не выбраны'}
        </p>
      </div>
    </aside>
  );
}
